var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"spinner-overlay"},[_c('b-spinner',{attrs:{"variant":"light","label":"Loading…"}})],1):_vm._e(),_c('router-view'),_c('portal-target',{attrs:{"name":"aiv-portals","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }